import React, { Component } from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import { Link } from "react-router-dom";
import colors from "./colors";
import ReactHTMLParser from "react-html-parser";
import minimize from './minimise_button_a.png'
/**
 *    Common Component for All Geoportals POpup
 */
class AboutModal extends Component {
  render() {
    console.log(this.props)
    return (
      <MDBContainer>
        {/* <MDBBtn color="primary" onClick={this.toggle(14)}>MDBModal</MDBBtn> */}
        <MDBModal
          isOpen={this.props.modal}
          toggle={this.props.toggle}
          centered
          backdrop={false}
          size="lg"
        >

         <div className="modal-header text-center"   
           
           toggle={this.props.toggle}
           style={{ background: colors.graphical, color: "white" }}>
            <h4 className="modal-title w-100 font-weight-bold">
             {this.props.title}
             </h4>
             <img src={minimize} class="btn-close" style={{width:"20px",height:"20px",cursor:"pointer"}} alt="Minimize" onClick={this.props.toggle}/>
           {/* <button
             type="button"
             class="btn-close"
             
             style={{background:"url(minimize)"}}
             aria-label="Minimize"
             onClick={this.props.toggle}
           ></button> */}
         </div>
          {/* <MDBModalHeader
            className="text-center"
            titleClass="w-100 font-weight-bold"
            style={{ backgroundColor: colors.final_header, color: "white" }}
            toggle={this.props.toggle}
          >
          
          </MDBModalHeader> */}
          <MDBModalBody style={{ textAlign: "justify",  overflowY: "scroll", height: "400px", }}>
            {ReactHTMLParser(this.props.bodycontent)}
          </MDBModalBody>
          <hr />
          <footer
            className="page-footer font-small "
            style={{
              backgroundColor: colors.white,
              borderTop: "1px solid #dee2e6",
              height: "auto",
            }}
          >
            {/* <div style={{ float: "right" }}>
              <MDBBtn
                onClick={this.props.toggle}
                style={{ backgroundColor: colors.final_header }}
              >
                Close
              </MDBBtn>
            </div> */}
            {/* <div style={{ float: "right" }}>
              <Link to={this.props.link}>
                {" "}
                <MDBBtn style={{ backgroundColor: colors.final_header }}>
                  Geoportal
                </MDBBtn>
              </Link>
            </div> */}
            {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
          </footer>
        </MDBModal>
      </MDBContainer>
    );
  }
}

export default AboutModal;
